<template>
    <!-- wangEditoe V4版规范 组件传入v-model使用规范  支持 IE10+ 浏览器(也就是ie11)   -->
    <!-- npm i wangeditor@latest --save 或者 npm i wangeditor@4 --save -->
    <!-- 使用: <me-wang-editor v-model="form.content"></me-wang-editor> -->
    <div class="MeWangEditor">
        <div ref="editor"></div>
    </div>
</template>

<script>
import E from "wangeditor";
import store from '@/store/store';
import env from "@/api/env";

export default {
    name: "MeWangEditor",
    // 父组件v-model传过来的值
    props: {
        value: {
            type: String,
            default: "",
        },
    },
    // 东: 组件只能绑定一个v-model  特别要注意的是子组件中的model需要定义两个值，prop是父组件v-model绑定的值，event你可以理解为子组件对v-model绑定值赋值的绑定事件
    model: {
        prop: "value", // 父组件v-model传过来的值
        event: "change", //绑定了这个自定义方法  你写什么名字都行
    },
    data() {
        return {
            editor: null, // 编辑器
            // content: "", // copy的值   不能直接改value(传进来的值)所以需要一个复制体
            fitst: false, // 只触发一次   我们只需要触发watch1次就是数据从无到有那一次 后面不需要触发(不然聚焦会失灵-到最后去)
        };
    },
    mounted() {
        // 初始化编辑器
        this.editor = new E(this.$refs.editor);
        // 绑定(显示)传过来的内容
        this.editor.config.onchange = (html) => {
            this.$emit('change', html) // 由于v-model双向绑定所以直接改  html充当copy值
            //this.content = html;
        };
        // this.editor.config.uploadImgShowBase64 = true; // 这种方式是把图片变成base64
        // 接口返回格式 application/json
        // const uploadUrl = process.env.NODE_ENV === 'production' ? process.env.VUE_APP_IMAGE_UPLOAD_API : '/upload';
        // this.editor.config.uploadImgServer = uploadUrl ; // 上传服务器端地址
        // 因为接口返回格式 'Content-Type': 'application/x-www-form-urlencoded' 所以我们要  自己实现上传图片!!!
        // 配置服务器端地址
        this.editor.config.uploadImgServer = env.IMG_COMMON_REQUEST_URL_PREFIX + '?type=1';
        this.editor.config.uploadImgMaxSize = 5 * 1024 * 1024; // 限制图片大小5M
        // 系统默认配置为:['jpg', 'jpeg', 'png', 'gif', 'bmp']
        // 自定义上传参数
        // 请求头
        this.editor.config.uploadFileName = "file"; //上传参数 自定义  file: (binary)  的file
        // 如果不写头也返回成功就注释掉请求头
        // this.editor.config.uploadImgHeaders = {
        //   Content-Type: "application/x-www-form-urlencoded", 又或者是
        //   Accept: "application/x-www-form-urlencoded",
        // };
        // 参数   header显示  params: {"field":"file","type":1}    token: xxxxxxxx
        this.editor.config.uploadImgParams = {
            params: '{"field":"file", "type":1}',
            token: store.getters.token ? store.getters.token : null,
        };
        // 回调函数
        this.editor.config.uploadImgHooks = {
            efore: function (xhr, editor, files) {
                // 图片上传之前触发
            },
            success: function (xhr, editor, result) {
                // 图片上传并返回结果，图片插入成功之后触发
            },
            fail: function (xhr, editor, result) {
                Message.error("插入图片失败！");
            },
            error: function (xhr, editor) {
                Message.error("插入图片失败！");
            },
            timeout: function (xhr, editor) {
                Message.error("插入图片失败！");
            },
            customInsert: function (insertImgFn, result) {
                // result 即服务端返回的接口
                console.log(result.data)
                // const { prefix_url, file_path_name } = result.data;
                const prefix_url = env.IMG_COMMON_URL_PREFIX;
                const files = result.data;
                // insertImgFn 可把图片插入到编辑器，传入图片 src ，执行函数即可(prefix_url + file_path_name这个就是src)
                if (typeof files !== 'string') {
                    for (let i = 0; i < files.length; i++) {
                        insertImgFn(prefix_url + files[i].file);
                    }
                } else {
                    insertImgFn(prefix_url + files);
                }


            },
        };
        this.editor.config.showLinkImg = true; // 隐藏“上传网络图片” 就写false
        /* 菜单 */
        this.editor.config.menus = [
            'head',  // 标题
            'bold',  // 粗体
            'fontSize',  // 字号
            'fontName',  // 字体
            'italic',  // 斜体
            'underline',  // 下划线
            'strikeThrough',  // 删除线
            'foreColor',  // 文字颜色
            'backColor',  // 背景颜色
            'link',  // 插入链接
            'list',  // 列表
            'justify',  // 对齐方式
            'quote',  // 引用
            //'emoticon',  // 表情
            'image',  // 插入图片
            'table',  // 表格
            'video',  // 插入视频
            'code',  // 插入代码
            'undo',  // 撤销
            'redo'  // 重复
        ]
        this.editor.create();

    },
    watch: {
        value(val) {
            if (!this.first) {
                this.editor.txt.html(val); // 重新设置编辑器内容
                this.first = true;
            }
        }
        // value: {
        //   handler(val) {
        //     this.content = val;
        //     if (this.editor) {
        //       this.editor.txt.html(this.content); // 重新设置编辑器内容
        //     }
        //   },
        //   immediate: true,
        // },
        // content(val) {
        //   // 触发双向绑定(这样子就做到了不需要再父组件中用方法接收子组件传过来的值来改变父组件中v-model绑定的值)
        //   this.$emit("change", val);
        // },
    },
    methods: {},
};
</script>

<style lang="scss">
.MeWangEditor {
    .w-e-text-container {
        min-height: 550px !important; // 编辑区域高度默认为 300px
        text-align: left;
    }
}

</style>